import * as React from 'react';
import { Notificar } from '../Notificador';
import { ObtengaReporteCrediticio } from '../../servicios/ReporteCrediticio';

export class RenderizarReporte extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ReporteHtml: "",
            redirect: null
        }
    }

    async componentDidMount() {
        this.Resultado();
    }

    Resultado = async () => {
        const resultado = await ObtengaReporteCrediticio();

        if(resultado.EsValido == false){
            resultado.Errores.forEach(error => {
                Notificar('error', error);
            });
            return;
        }

        this.setState({
            ReporteHtml: resultado.ReporteHtml,
        });
    }

    render() {
        return (
            <div dangerouslySetInnerHTML={{ __html: this.state.ReporteHtml }} />
        );
    }
}

export default RenderizarReporte;